<section class="header">
  <p class="title">Mass Update Tags</p>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</section>

<section class="body">
  <ng-container *ngIf="relatedTags$ | async as relatedTags; else LoadingOrError">
    <section class="body__wrapper">
      <section class="feedback-container mb-4">
        <app-alert-banner [type]="'info'">
          <p>
            Use the controls beside each tag to <strong>Add</strong>, <strong>Remove</strong> or to
            <strong>Clear</strong> the tags selection below.
          </p>
        </app-alert-banner>
      </section>

      <p class="mb-2">Existing {{ this.relatedToType.toLowerCase() }} related tags:</p>
      <section class="tags-container">
        <ng-container *ngIf="hasRelatedTags(relatedTags); else NoRelatedTags">
          <mat-chip-list>
            <mat-chip #chip="matChip" *ngFor="let tag of relatedTags | keyvalue" [selectable]="false" [value]="tag.key">
              {{ tag.key }}
              <mat-icon class="tag-controller ml-1" [matTooltip]="'Add tag'" (click)="onTagClick(chip, 'add')"
                >add_circle</mat-icon
              >
              <mat-icon class="tag-controller" [matTooltip]="'Remove tag'" (click)="onTagClick(chip, 'remove')"
                >remove_circle</mat-icon
              >
              <mat-icon class="tag-controller" [matTooltip]="'Clear selection'" (click)="onTagClick(chip, 'clear')"
                >cancel</mat-icon
              >
            </mat-chip>
          </mat-chip-list>
        </ng-container>
        <ng-template #NoRelatedTags>
          <p class="my-4 text-center">No tags found.</p>
        </ng-template>
      </section>

      <mat-divider class="my-4"></mat-divider>

      <section class="create-tags">
        <p class="mb-2">
          You can also create new tags that will be applied to all selected
          {{ relatedToType === 'Contact' ? 'contacts' : relatedToType === 'Company' ? 'companies' : 'projects' }}.
        </p>
        <mat-form-field class="w-full mb-2">
          <mat-chip-list #chipList class="py-2">
            <mat-chip
              *ngFor="let tag of newInputTypedTags"
              [selectable]="false"
              [removable]="true"
              (removed)="removeNewTag(tag)"
            >
              {{ tag }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              #tagInput
              placeholder="New tag..."
              class="py-2"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addNewTag($event)"
              (focus)="tagInput.focused = true"
              (blur)="tagInput.focused = false"
            />
          </mat-chip-list>

          <!-- Feedback messages -->
          <mat-hint *ngIf="tagInput.focused" class="mt-2">
            Press <strong>TAB</strong> key after finishing typing to add a new tag
          </mat-hint>
        </mat-form-field>
      </section>

      <section class="selected-tags">
        <div class="selected-tags__wrapper">
          <div class="selected-tags__added-column">
            <p class="column-title"><strong>Added Tags</strong></p>
            <div *ngIf="tagsToBeAdded.length > 0 || newInputTypedTags.length > 0" class="column-tags">
              <mat-chip-list>
                <mat-chip *ngFor="let addedTag of tagsToBeAdded" [selectable]="false" [removable]="false">
                  {{ addedTag }}
                </mat-chip>
                <mat-chip *ngFor="let addedTagFromInput of newInputTypedTags" [selectable]="false" [removable]="false">
                  {{ addedTagFromInput }}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>

          <mat-divider [vertical]="true"></mat-divider>

          <div class="selected-tags__removed-column">
            <p class="column-title"><strong>Removed Tags</strong></p>
            <div *ngIf="tagsToBeRemoved.length > 0 || newInputTypedTags.length > 0" class="column-tags">
              <mat-chip-list>
                <mat-chip *ngFor="let removedTag of tagsToBeRemoved" [selectable]="false" [removable]="false">
                  {{ removedTag }}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
      </section>
    </section>
  </ng-container>
</section>

<section class="actions">
  <ng-container *ngIf="tagsError$ | async; else DefaultControllers">
    <button mat-stroked-button (click)="discard()">Close</button>
  </ng-container>
  <ng-template #DefaultControllers>
    <button mat-stroked-button class="mr-4" (click)="discard()">Cancel</button>
    <button mat-flat-button [color]="'primary'" (click)="save()" [disabled]="isSaveBtnDisabled()">
      <span *ngIf="!isProcessing">Save</span>
      <mat-spinner
        *ngIf="isProcessing"
        diameter="24"
        [strokeWidth]="2"
        [mode]="'indeterminate'"
        [color]="'primary'"
      ></mat-spinner>
    </button>
  </ng-template>
</section>

<ng-template #LoadingOrError>
  <section class="flex flex-col items-center justify-center h-full">
    <ng-container *ngIf="tagsError$ | async; else Loading">
      <img class="no-tags-image" src="assets/images/empty_list.svg" alt="No Tags Found" />
      <h5 class="mt-0 text-center">Unable to fetch tags list at the moment.</h5>
      <h5 class="m-0 text-center">Please try again later.</h5>
    </ng-container>
    <ng-template #Loading>
      <mat-spinner class="m-auto" [diameter]="128" [strokeWidth]="3"></mat-spinner>
    </ng-template>
  </section>
</ng-template>
